import React from 'react';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './AuthorizationCodeField.css';

class AuthorizationCodeField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  render() {
    const {
      input: { value },
      meta,
      placeholder,
      className,
      disabled,
      pinAccessImprovement,
    } = this.props;

    return (
      <div className={`${styles.wrapper} col-sm-4 ${className}`}>
        <input
          value={value}
          placeholder={placeholder}
          className={`form-control`}
          onChange={this._onChange}
          type={this.state.showPassword ? 'text' : 'password'}
          onKeyPress={this._onKeyPress}
          disabled={disabled}
        />
        {pinAccessImprovement && (
          <div className={styles['pin-code-text']}>
            <small>This is auto generated PIN. Edit to change</small>
          </div>
        )}
        <i
          type="button"
          onClick={this._showPasswordButton}
          className={`${styles['eye-button']} ${
            this.state.showPassword
              ? 'glyphicon glyphicon-eye-close'
              : 'glyphicon glyphicon-eye-open'
          }`}
        />
        {meta.touched && meta.error && (
          <label className="error">{meta.error}</label>
        )}
      </div>
    );
  }

  _onKeyPress = e => {
    e.persist();
    if ('0123456789'.indexOf(e.key) === -1) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  _onChange = e => {
    const {
      maxLength,
      input: { onChange },
    } = this.props;
    const hasMaxLength = maxLength !== null && maxLength !== undefined;
    if (!hasMaxLength) {
      onChange(e.target.value);
    } else if (e.target.value.length <= maxLength) {
      onChange(e.target.value);
    }
  };

  _showPasswordButton = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };
}

const mapFlagsToProps = flags => ({
  pinAccessImprovement: flags.pinAccessImprovement,
});

export default withFeatureFlags(mapFlagsToProps)(AuthorizationCodeField);
